import { render, staticRenderFns } from "./EnglishTasks.vue?vue&type=template&id=0025d791&scoped=true&"
import script from "./EnglishTasks.vue?vue&type=script&lang=js&"
export * from "./EnglishTasks.vue?vue&type=script&lang=js&"
import style0 from "./EnglishTasks.vue?vue&type=style&index=0&id=0025d791&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0025d791",
  null
  
)

export default component.exports